import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import RebatesRCTIListFilters from './RebatesRCTIListFilters';
import {updateRebatesRCTIListFilters, exportRebatesRCTI, listRebatesRCTI, 
    bulkDownloadRebatesRCTI, listRebatesRCTIStatus} from '../../actions/rebatesRCTIActions';
import RebatesRCTIList from './RebatesRCTIList';
import { mustBeArray, requestHasError } from '../../utils/lib';
import { push } from '../../utils/navigation';
import { BASE_URL, DEFAULT_DATE_FORMAT, EXPORTED_STATUS_ID, READY_FOR_EXPORT_STATUS_ID } from '../../constants';
import { toastr } from 'react-redux-toastr';

const RebatesRCTIListView = props => {
    const {updateRebatesRCTIListFilters, dispatch, filters, rebatesList, 
            exportRebatesRCTI, bulkDownloadRebatesRCTI, listRebatesRCTI, listRebatesRCTIStatus} = props;
    const [allSelected, setAllSelected] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [bulkExporting, setBulkExporting] = useState(false);
    const [exportingRebates, setExportingRebates] = useState([]);
    const [bulkDownloading, setBulkDownloading] = useState(false);

    const handleFilterChange = ({value, field}) => {
        if(['dateFrom','dateTo'].includes(field)){
            value = value.format(DEFAULT_DATE_FORMAT);
        }
        const updatedFilters = {...filters, [field]: value};
        dispatch(updateRebatesRCTIListFilters(updatedFilters));
    };

    const handleResetFilter = () => {
        dispatch(updateRebatesRCTIListFilters({dateFrom: "", dateTo: "", clientName: "", statusID: ""}));
                fetchRebatesRCTI({hasFilters: false});
    };
    const handleSearch = () => {
        fetchRebatesRCTI({hasFilters: true});
    };

    useEffect(() => {
        fetchRebatesRCTI({hasFilters: true});
        fetchStatusList();
    }, []);

    const fetchRebatesRCTI = async({hasFilters}) => {
        let currentFilters = hasFilters ? 
        {dateFrom: filters.dateFrom, dateTo: filters.dateTo, clientName: filters.clientName, statusID: filters.statusID} :
        {dateFrom: "", dateTo: "", clientName: "", statusID: ""}; 

        const resp = await dispatch(listRebatesRCTI(currentFilters));
        return resp;
    };
    const fetchStatusList = () => {
        dispatch(listRebatesRCTIStatus()).then(x => {
            setStatusList(mustBeArray(x && x.data));
        });
    };
    const handleCheckboxSelection = row => {
        let updatedSelectedRows = [];
        if(selectedRows.includes(row.id)){
            updatedSelectedRows = selectedRows.filter((a) => a !== row.id);
            setAllSelected(false);
        }
        else{
            updatedSelectedRows = [...selectedRows, row.id];
            if(updatedSelectedRows.length === (rebatesList.filter(o => o.exportStatusID === READY_FOR_EXPORT_STATUS_ID)).length){
                setAllSelected(true);
            }
        }
        return setSelectedRows(updatedSelectedRows);
        
    };
    const handleAllSelected = () => {
        if(allSelected){
            setSelectedRows([]);
            setAllSelected(false);
        }
        else{
            let newSelectedRows = mustBeArray(rebatesList).reduce((a,b) => {
                return(b.exportStatusID === READY_FOR_EXPORT_STATUS_ID ? [...a,b.id] : [...a]);
            },[]);
            setSelectedRows(newSelectedRows);
            setAllSelected(true);
        }
    };
    const handleBulkDownload = () => {
        setBulkDownloading(true);
        const payLoad = {
            dateFrom: filters.dateFrom, dateTo: filters.dateTo, clientName: filters.clientName, statusID: filters.statusID
        };
        dispatch(bulkDownloadRebatesRCTI({...payLoad})).then(x => {
            setBulkDownloading(false);
        });
    };
    const handleCreate = () => {
        dispatch(push(`${BASE_URL}/rebatesRCTI/create`));
    };
    const handleBulkExport = () => {
        if(_.isEmpty(selectedRows)){
            return toastr.error("Bulk Export Error: Rebates are required.");
        }
        setBulkExporting(true);
        dispatch(exportRebatesRCTI({rebates: selectedRows})).then(x => {
            setBulkExporting(false);
            if((requestHasError({x}))){
                toastr.error(`Export Error, error: ${getErrorMessage({x})}`);            
            }
            else{
                if(!_.isEmpty(mustBeArray(x && x.data))){
                    toastr.error(`Failed to Export ${mustBeArray(x.data).toString()}`);
                }
                else{
                    toastr.success("Rebates RCTI exported.");
                }
            }
            setAllSelected(false);
            setSelectedRows([]);
            fetchRebatesRCTI({hasFilters: true});
        });
    };

    const handleExport = ({data}) => {
        setExportingRebates([...exportingRebates, data.id]);
        dispatch(exportRebatesRCTI({rebates: [data.id]})).then(x => {
            if(!(requestHasError({x}))){
                toastr.success("Rebates RCTI exported.");
            }
            fetchRebatesRCTI({hasFilters: true}).then(x => {
                let newExportingRebates = _.filter(exportingRebates, o => o !== data.id);
                setExportingRebates(newExportingRebates);
            });
            let newSelectedRows = _.filter(selectedRows, o => o !== data.id);
            setSelectedRows(newSelectedRows);
            setAllSelected(false);
        });
    };

    const handleRCTIView = data => {
        dispatch(push(data.exportStatusID === EXPORTED_STATUS_ID ? `${BASE_URL}/rebatesRCTI/${data.id}` :
        `${BASE_URL}/rebatesRCTI/${data.id}/edit`));
    };

    return(
        <div className="mb-1">
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>Rebates RCTI</h4>
                </div>
            </div>
            <Row className="mb-2">
                <Col sm={12} md={7} lg={6}>
                    <RebatesRCTIListFilters 
                        filters={filters} 
                        handleFilterChange={handleFilterChange}
                        handleCreate={handleCreate}
                        handleSearch={handleSearch}
                        handleResetFilter={handleResetFilter}
                        statusList={statusList}
                    />
                </Col>
            </Row>
            <div className="mb-1 rcti-list-action-buttons">
                <button className={`btn btn-success bold ${bulkExporting ? "no-pointer-events" : ""}`} 
                            onClick={handleBulkExport}>
                                {bulkExporting ?  "Exporting" : "Bulk Export"}
                </button>
                <button className={`btn btn-primary ml-1 ${bulkDownloading ? "no-pointer-events" : ""}`} onClick={handleBulkDownload} > 
                    <i className="fa fa-arrow-down" aria-hidden="true"></i> &nbsp;{bulkDownloading ? "Downloading" : "Download"}
                </button>
            </div>
            <div className="clearfix"/>
            <RebatesRCTIList 
                handleCheckboxSelection={handleCheckboxSelection}
                handleAllSelected={handleAllSelected}
                allSelected={allSelected}
                selectedRows={selectedRows}
                rebatesList={rebatesList}
                handleRCTIView={handleRCTIView}
                handleExport={handleExport}
                exportingRebates={exportingRebates}
            />
        </div>
    );
};

function mapStateToProps(state, ownProps){
  
    return {
      filters: state.rebatesRCTI && state.rebatesRCTI.listFilters || {},
      rebatesList: state.rebatesRCTI && state.rebatesRCTI.items 
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      updateRebatesRCTIListFilters,
      exportRebatesRCTI,
      bulkDownloadRebatesRCTI,
      listRebatesRCTI,
      listRebatesRCTIStatus
    };
  }

export default connect(mapStateToProps, mapDispatchToProps) (RebatesRCTIListView);